/**
 * TanStack Query hooks for `publisher-invoicing-day-wise-or-campaign-wise`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	publisherInvoicingDayWiseOrCampaignWiseQueryKeys,
	type CreatePublisherInvoicingDayWiseOrCampaignWiseBody,
	type ListPublisherInvoicingDayWiseOrCampaignWiseResponse,
	type PublisherInvoicingDayWiseOrCampaignWiseRow,
} from "./api";

export function usePublisherInvoicingDayWiseOrCampaignWiseList(): UseQueryResult<ListPublisherInvoicingDayWiseOrCampaignWiseResponse, Error> {
	return useQuery({
		queryKey: publisherInvoicingDayWiseOrCampaignWiseQueryKeys.list(),
		queryFn: list,
	});
}

export function usePublisherInvoicingDayWiseOrCampaignWiseCreate(): UseMutationResult<PublisherInvoicingDayWiseOrCampaignWiseRow, Error, CreatePublisherInvoicingDayWiseOrCampaignWiseBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publisherInvoicingDayWiseOrCampaignWiseQueryKeys.all });
		},
	});
}

export function usePublisherInvoicingDayWiseOrCampaignWiseDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publisherInvoicingDayWiseOrCampaignWiseQueryKeys.all });
		},
	});
}
